jQuery(function ($) {
  // read more wrapper
  $('.read-more-wrapper').each(function () {
    var $readMoreWrapper = $(this);
    var readMoreMaxHeight = $readMoreWrapper.attr('data-max-height');

    if (typeof readMoreMaxHeight === 'undefined') {
      readMoreMaxHeight = 300;
    }

    if ($readMoreWrapper.height() > readMoreMaxHeight) {
      $readMoreWrapper.addClass('is-close').append('<div class="read-more-footer"><div class="i-wrapper"><i class="fal fa-chevron-down" aria-hidden="true"></i></div></div>');
      $readMoreWrapper.css('height', readMoreMaxHeight);
      $readMoreWrapper.on('click', '.i-wrapper', function () {
        $(this).parents('.read-more-wrapper').removeClass('is-close').css('height', 'auto');
        $(this).parent().remove();
      });
    }
  });
  // dealticker
  $('.card-more-info').on('click', function (e) {
    e.preventDefault();

    $(this).parents('.card-overlay').toggleClass('open');
    $(this).toggleClass('open');
  });

  $('.card-close-more-info').on('click', function (e) {
    e.preventDefault();

    $(this).parent().toggleClass('open');
    $(this).parents('.card-overlay').toggleClass('open');
  });
});
